import React, { useState, useMemo } from 'react';
import { Segment, Bubble } from 'tea-component';

import { SEGMENT_CHART_SOURCE } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import classNames from 'classnames';
import SteamIcon from '@/pages/intelligence/assets/svg/dataSource/steam-icon.svg';
import MscienceIcon from '@/pages/intelligence/assets/svg/dataSource/mscience-bg.svg';
import Npdicon from '@/pages/intelligence/assets/svg/dataSource/npd-icon.svg';
import newzooIcon from '@/pages/home/assets/svg/dataSource/databarin.svg';
import { useIntl, getLocale } from 'umi';
import { NewzooToDatabrain } from '@intelligence/utils/constant';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { useDeepCompareEffect } from 'ahooks';

// 可视化统一组件,获取到数据，根据不同类型切换echart
const ChartTypeTab: React.FC<any> = (props: any) => {
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const SEGMENT_CHART_ICONMETRICS = {
    pcMetricsTable: [
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={SteamIcon} className="dbi-pcGame-select-icon" />
            <Bubble placement="top" dark content="SensorTower">
              Steam
            </Bubble>
          </div>
        ),
        value: '1',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={MscienceIcon} className="dbi-pcGame-select-icon" />
            <Bubble placement="top" dark content="SensorTower">
              Mscience
            </Bubble>
          </div>
        ),
        value: '2',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={Npdicon} className="dbi-pcGame-select-icon" />
            <Bubble placement="top" dark content="SensorTower">
              NPD
            </Bubble>
          </div>
        ),
        value: '3',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={newzooIcon} className="dbi-pcGame-select-icon" />
            <Bubble placement="top" dark content="SensorTower">
              {NewzooToDatabrain}
            </Bubble>
          </div>
        ),
        value: '12',
      },
    ],
    pcPCU: [],
    mobilenewrelease: [
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('ios')} className="dbi-pcGame-select-icon" />
            <span>{`${formatMessage({ id: 'dbi_store_rank_top_free' })}(#1-10)`}</span>
          </div>
        ),
        value: 'appstore top free',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('ios')} className="dbi-pcGame-select-icon" />
            <span>{`${formatMessage({ id: 'dbi_store_rank_top_grossing' })}(#1-10)`}</span>
          </div>
        ),
        value: 'appstore top grossing',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('android')} className="dbi-pcGame-select-icon" />
            <span>{`${formatMessage({ id: 'dbi_store_rank_top_free' })}(#1-10)`}</span>
          </div>
        ),
        value: 'googleplay top free',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('android')} className="dbi-pcGame-select-icon" />
            <span>{`${formatMessage({ id: 'dbi_store_rank_top_free' })}(#1-10)`}</span>
          </div>
        ),
        value: 'googleplay top grossing',
      },
    ],
    pcnewrelease: [
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('source_steam')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_metric_source_steam_pcu' })}</span>
          </div>
        ),
        value: 'source_steam__pcu',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('steam')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_new_and_trending' })}</span>
          </div>
        ),
        value: 'steam new and trending',
      },
    ],
    consolenewrelease: [
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('xbox')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_new_release' })}</span>
          </div>
        ),
        value: 'xbox new release',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img
              src={getDataSourceIcon('playstationbalck')}
              className="dbi-pcGame-select-icon db-invert-unset"
            />
            <span>{formatMessage({ id: 'dbh_storerank_newgames' })}</span>
          </div>
        ),
        value: 'playstation new games',
      },
    ],
    pcupcoming: [
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('steam')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_top_wish_lists' })}</span>
          </div>
        ),
        value: 'steam top wish lists',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('steam')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_metric_steam_followers' })}</span>
          </div>
        ),
        value: 'steamfollowers',
      },
    ],
    consoleupcoming: [
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('xbox')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_xbox_upcoming' })}</span>
          </div>
        ),
        value: 'xbox upcoming',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img
              src={getDataSourceIcon('playstationbalck')}
              className="dbi-pcGame-select-icon db-invert-unset"
            />
            <span>{formatMessage({ id: 'dbh_storerank_comingsoon' })}</span>
          </div>
        ),
        value: 'playstation coming soon',
      },
    ],
    mobiledetailStorerankfree: [
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('ios')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_top_free' })}</span>
          </div>
        ),
        value: 'appstore top free',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('ios')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_top_grossing' })}</span>
          </div>
        ),
        value: 'appstore top grossing',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('android')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_top_free' })}</span>
          </div>
        ),
        value: 'googleplay top free',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('android')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_top_grossing' })}</span>
          </div>
        ),
        value: 'googleplay top grossing',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('android')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_top_popular' })}</span>
          </div>
        ),
        value: 'googleplay top popular',
      },
    ],
    mobiledetailStorerankpaid: [
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('ios')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_top_paid' })}</span>
          </div>
        ),
        value: 'appstore top paid',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('ios')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_top_grossing' })}</span>
          </div>
        ),
        value: 'appstore top grossing',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('android')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_top_paid' })}</span>
          </div>
        ),
        value: 'googleplay top paid',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('android')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_top_grossing' })}</span>
          </div>
        ),
        value: 'googleplay top grossing',
      },
      {
        text: (
          <div className="dbi-pcGame-select-flex">
            <img src={getDataSourceIcon('android')} className="dbi-pcGame-select-icon" />
            <span>{formatMessage({ id: 'dbi_store_rank_top_popular' })}</span>
          </div>
        ),
        value: 'googleplay top popular',
      },
    ],
  } as any;

  const {
    defaultValue,
    selectType = '',
    sendSegment,
    isIconMetrics = false, // 是否是带icon的指标
    chartSegmentList, // 组件外部传入segmmentlist
  } = props;

  const [value, setValue] = useState(defaultValue);
  useDeepCompareEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const changeVal = (value: string) => {
    sendSegment(value);
    setValue(value);
  };

  const options = useMemo(() => {
    if (chartSegmentList) {
      return chartSegmentList?.map((item: any) => {
        return {
          text: (
            <div className="dbi-pcGame-select-flex">
              <img
                src={getDataSourceIcon(
                  item.dataSource === 'playstation' ? 'playstationwhite' : item.dataSource,
                )}
                className="dbi-pcGame-select-icon"
              />
              <span>{formatMessage({ id: item.textKey })}</span>
            </div>
          ),
          value: item.value,
        };
      });
    }
    const list = SEGMENT_CHART_SOURCE[selectType]?.map((item: any) => ({
      ...item,
      text: formatMessage({ id: item.text }),
    }));
    return isIconMetrics ? SEGMENT_CHART_ICONMETRICS[selectType] : list;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectType, isIconMetrics, locale, chartSegmentList]);

  return (
    <>
      {options?.length && (
        <Segment
          className={classNames({
            'dbi-pcGame-segment-box': isIconMetrics,
          })}
          value={value}
          onChange={changeVal}
          options={options}
        />
      )}
    </>
  );
};

export default ChartTypeTab;
